import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=b97614d8&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=b97614d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97614d8",
  null
  
)

export default component.exports